import React from "react";
import Alert from "./Alert";

export default ({ children }) => <Alert appearance="error">{children}</Alert>;
